import { useFetchWhistleBlowingsSummaryQuery } from 'features/private-views/whistle-blowings/list-whistle-blowings/whistleBlowingsListApiSlice'
import { AlertCircle, ChevronRight } from 'react-feather'
import { useNavigate } from 'react-router-dom'
import { Badge, Card, CardBody, Spinner } from 'reactstrap'
import { COLOR_MAP } from 'config/templateConfig'

const SectionWhistleblowingCards = ({ mode = 'secondary', params = {} }) => {
  const navigate = useNavigate()
  const { data: summaryData, isLoading: isLoadingSummary } =
    useFetchWhistleBlowingsSummaryQuery()

  const data = summaryData?.data ||
    summaryData || {
      totalGrievance: 0,
      resolvedGrievance: 0,
    }

  const unsettledReports =
    (data.totalGrievance ?? 0) - (data.resolvedGrievance ?? 0)

  // Mode Styling Configuration matching GenericLinkWidget
  let paddingClass = 'p-4'
  let titleClass = 'fw-bold mb-1'
  let iconSize = 24
  let iconPaddingClass = 'p-2 me-3'
  let descClass = 'mb-0'

  let isTinySquare = mode === 'tiny-square'
  let isTiny = mode === 'tiny' || isTinySquare

  if (mode === 'primary') {
    paddingClass = 'p-4'
    titleClass = 'fw-bold mb-1'
    iconSize = 36
    iconPaddingClass = 'p-3 me-3'
    descClass = 'mb-0'
  } else if (mode === 'compact') {
    paddingClass = 'p-3'
    titleClass = 'fw-bold mb-1'
    iconSize = 18
    iconPaddingClass = 'p-2 me-2'
    descClass = 'mb-0'
  } else if (isTiny) {
    paddingClass = isTinySquare ? 'p-2' : 'p-2 px-3'
    titleClass = `fw-bold mb-0 ${isTinySquare ? 'text-center' : 'text-start'}`
    iconSize = 16
    iconPaddingClass = 'p-2'
  }

  // Define accent colors
  const cardColor = COLOR_MAP[params.color] || '#EA580C'

  return (
    <div className={!isTiny ? 'h-100' : ''}>
      <Card
        onClick={() => navigate('/whistle-blowings')}
        className={`${!isTiny ? 'h-100' : ''} border-0 shadow-sm transition-all`}
        style={{
          background: cardColor,
          backgroundImage: 'linear-gradient(135deg, rgba(255,255,255,0.15) 0%, rgba(0,0,0,0.05) 100%)',
          color: '#ffffff',
          border: 'none',
          cursor: 'pointer',
          transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
          aspectRatio: isTinySquare ? '1/1' : undefined,
          width: '100%',
          minHeight: isTinySquare ? undefined : mode === 'tiny' ? '68px' : mode === 'primary' ? '236px' : mode === 'compact' ? '110px' : '152px',
          borderRadius: isTiny ? '12px' : '20px',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: isTinySquare ? 'center' : 'flex-start',
          boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = 'translateY(-5px)'
          e.currentTarget.style.boxShadow = '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)'
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = 'translateY(0)'
          e.currentTarget.style.boxShadow = '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)'
        }}
      >
        <CardBody className={`${paddingClass} ${isTiny ? '' : 'flex-grow-1'} d-flex flex-column justify-content-center ${isTinySquare ? 'align-items-center justify-content-center' : ''}`}>
          <div className={isTinySquare ? 'd-flex flex-column align-items-center justify-content-center mb-0 w-100' : `d-flex align-items-center w-100 ${mode === 'primary' ? 'mb-2' : 'mb-0'}`}>
            <div
              className={`${iconPaddingClass} ${isTinySquare ? 'mb-2' : 'me-3'} rounded-circle d-flex align-items-center justify-content-center`}
              style={{
                backgroundColor: 'rgba(255, 255, 255, 0.15)',
                backdropFilter: 'blur(8px)',
                border: '1px solid rgba(255, 255, 255, 0.2)',
                color: '#ffffff',
                border: 'none',
                flexShrink: 0,
                width: mode === 'primary' ? '64px' : (mode === 'compact' || isTiny) ? '36px' : '48px',
                height: mode === 'primary' ? '64px' : (mode === 'compact' || isTiny) ? '36px' : '48px',
                boxShadow: 'inset 0 0 10px rgba(255,255,255,0.1)'
              }}
            >
              <AlertCircle size={iconSize} />
            </div>
            
            <div className={isTinySquare ? 'w-100' : 'flex-grow-1 d-flex flex-column justify-content-center'}>
              <div
                className={`${titleClass} ${isTiny ? 'd-block text-truncate' : ''}`}
                style={{ 
                  color: '#ffffff', 
                  fontSize: isTiny ? '14px' : mode === 'primary' ? '28px' : mode === 'compact' ? '15px' : '18px',
                  fontWeight: 600,
                  marginBottom: !isTiny ? '2px' : '0',
                  lineHeight: 1.1
                }}
              >
                Pengaduan
              </div>
              
              {!isTiny && (
                <div className="small d-flex align-items-center" style={{ color: 'rgba(255,255,255,0.7)', fontSize: mode === 'compact' ? '11px' : '12px', marginTop: mode === 'primary' ? '4px' : '2px' }}>
                  <ChevronRight size={10} className="me-1" />
                  <span>Lihat Detail Pengaduan</span>
                </div>
              )}
              {isTiny && unsettledReports > 0 && (
                <div className="d-flex align-items-center" style={{ alignSelf: isTinySquare ? 'center' : 'flex-start' }}>
                   <Badge color="light" className="text-dark fw-bold px-2 py-1 mt-1" style={{ fontSize: 11 }}>
                     {unsettledReports} Laporan
                   </Badge>
                </div>
              )}
            </div>
          </div>

          {!isTiny && (
            <div className="mt-2" style={{ color: 'rgba(255,255,255,0.7)', fontSize: mode === 'compact' ? '12px' : '14px', lineHeight: '1.4' }}>
              {isLoadingSummary ? (
                <div className="d-flex mt-1">
                  <Spinner size="sm" color="light" />
                </div>
              ) : unsettledReports > 0 ? (
                <div className={`d-flex flex-column gap-1 ${mode==='compact'?'mt-0':'mt-1'}`}>
                  <Badge color="light" className="text-dark fw-bold w-auto align-self-start py-1 px-2 mb-1" style={{ fontSize: mode === 'compact' ? 10 : 12}}>
                    {unsettledReports} Butuh Tindakan
                  </Badge>
                  <span style={{ color: 'rgba(255,255,255,0.8)', fontSize: mode === 'compact' ? 12 : 14 }}>
                    dari {data.totalGrievance} laporan
                  </span>
                </div>
              ) : data.totalGrievance > 0 ? (
                <div className={`d-flex flex-column gap-1 ${mode==='compact'?'mt-0':'mt-1'}`}>
                  <span style={{ color: 'rgba(255,255,255,0.8)', fontSize: mode === 'compact' ? 12 : 14 }}>
                    Semua laporan terselesaikan
                  </span>
                </div>
              ) : (
                <div className={`d-flex flex-column gap-1 ${mode==='compact'?'mt-0':'mt-1'}`}>
                  <span style={{ color: 'rgba(255,255,255,0.8)', fontSize: mode === 'compact' ? 12 : 14 }}>
                    Belum ada laporan
                  </span>
                </div>
              )}
            </div>
          )}
        </CardBody>
      </Card>
    </div>
  )
}

export default SectionWhistleblowingCards
